export default "__VITE_ASSET__Dmn6LrYn__"